import { gql } from '@apollo/client';
import type {
  AffiliationRelations,
  AffiliationTypes,
} from '@generated/graphql';
import type { Account } from '@interfaces/account';
import { AFFILIATION_STATE_FIELDS } from './affiliationStateFields';

export const UPDATE_AFFILIATIONS = gql`
  mutation updateAffiliations($input: UpdateAffiliationsInput!) {
    updateAffiliations(input: $input) {
      account {
        id
        affiliations { ${AFFILIATION_STATE_FIELDS} }
      }
      incompleteAffiliations {
        user {
          id
          firstName
          lastName
        }
        type
        relation
        incompleteFields
      }
    }
  }
`;

export type AffiliationUpdateData = {
  updateAffiliations: {
    account: Partial<Account>;
    incompleteAffiliations: {
      incompleteFields: string[];
      relation: AffiliationRelations;
      type: AffiliationTypes;
    }[];
  };
};
